export var PSYCH_NOTE_OVERVIEW = {
    paragraph1: 'Psychotherapy notes, also called process notes, are personal notes of a mental health care provider that ' +
        'are separate from the patient’s medical record and are not accessible by the patient or other providers. ',
    paragraph2: 'Psychotherapy notes cannot be disclosed without the express authorization of the patient, except in ' +
        'limited circumstances required by law. This feature should not be used for any other purpose other than the ' +
        'documentation or analysis of the contents of a counseling session by a mental health professional. ',
};
export var DELETE_PSYCH_NOTE_TEXT = 'Removing this note will delete all progress and is ' +
    'not recoverable. Are you sure you want to delete this psychotherapy note?';
export var DELETE_ERROR = 'There was an error deleting this Psychotherapy Note, please try again.';
export var PRINT_ERROR = 'There was an error printing this Psychotherapy Note, please try again.';
export var SAVE_DIALOG_ERROR = 'Saving has failed. In order to avoid losing your progress, please stay on this page. You can ' +
    'copy your changes, refresh the page to view the latest version, and try again.';
export var IN_NOTE_SAVE_DIALOG_ERROR = 'Saving the psychotherapy note has failed. To avoid losing your progress, copy your changes, save and close the ' +
    'clinical note, reopen the clinical note, and then try saving again.';
export var SETTINGS_SAVE_ERROR = 'Failed to update psychotherapy note settings. Try refreshing the page or contact your system admin if the problem persists.';
export var GENERIC_ERROR_HEADER = 'Oh no! Looks like something went wrong!';
export var GENERIC_ERROR_INSTRUCTIONS = 'This data didn’t load. Try refreshing the page or contact your system admin if the problem persists.';
export var FEEDBACK_LINK = 'https://www.getfeedback.com/r/rlRYTn6u/';
export var PSYCH_NOTE_SETTINGS_KEYS = {
    enabled: 'psychNotesEnabled',
    dismissed: 'aboutDialogDismissed',
};
export var PSYCH_OPEN_ERROR = {
    title: 'Failed to Load Note',
};
export var PSYCH_CREATE_ERROR = {
    title: 'Failed to Create Note',
};
